/** Shared GIF limits, matching mobile's image-picker/index.js constants. */
export const MAX_GIF_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB
export const MAX_GIF_DURATION_SECONDS = 5;
